<template>
  <div class="row">
    <div class="col-xl-12">
      <!-- begin: Child route (Create / Detail / Edit / View) -->
      <router-view />
      <!-- end: Child route -->

      <div
        v-show="$route.path == '/StockCoverDays/List'"
        class="kt-portlet kt-portlet--mobile"
      >
        <div class="kt-portlet__head kt-portlet__head--lg">
          <div class="kt-portlet__head-label">
            <span class="kt-portlet__head-icon">
              <i class="fas fa-boxes"></i>
            </span>
            <h3 class="kt-portlet__head-title">
              {{ this.$route.meta.breadcrumb }}
            </h3>
          </div>
        </div>
        <div class="kt-portlet__body">
          <!-- begin: Search Form -->
          <form class="kt-form" @submit="formSubmit" ref="searchForm">
            <div class="row">
              <div class="col-xl-4 col-lg-4 col-md-4 col-sm-6 col-xs-12">
                <div class="form-group">
                  <label>คลังสินค้า :</label>
                  <select2
                    :css-style="'width: 100%;'"
                    :css-class="'form-control m-select2'"
                    :id="'scvdList_plantKey'"
                    :name="'scvdList_plantKey'"
                    :select2-options="plantOptions"
                    v-model="searchPlant"
                    ref="scvdList_plantKeySelect2"
                  ></select2>
                </div>
              </div>
              <div class="col-xl-4 col-lg-4 col-md-4 col-sm-6 col-xs-12">
                <div class="form-group">
                  <label>ปี :</label>
                  <select2
                    :css-style="'width: 100%;'"
                    :css-class="'form-control m-select2'"
                    :id="'scvdList_yearKey'"
                    :name="'scvdList_yearKey'"
                    :select2-options="searchYearOptions"
                    v-model="searchYear"
                    ref="scvdList_yearKeySelect2"
                  ></select2>
                </div>
              </div>
              <div class="col-xl-4 col-lg-4 col-md-4 col-sm-6 col-xs-12">
                <div class="form-group">
                  <label>สถานะ :</label>
                  <select2
                    :css-style="'width: 100%;'"
                    :css-class="'form-control m-select2'"
                    :id="'scvdList_statusKey'"
                    :name="'scvdList_statusKey'"
                    :select2-options="statusOptions"
                    v-model="searchStatus"
                    ref="scvdList_statusKeySelect2"
                  ></select2>
                </div>
              </div>
            </div>
            <div class="row mb-3">
              <div class="col-xl-6">
                <button type="submit" class="btn btn-primary">
                  ค้นหา
                </button>
                <button
                  type="reset"
                  class="btn btn-secondary"
                  @click="formReset"
                >
                  ล้างค่าทั้งหมด
                </button>
              </div>
              <div class="col-xl-6 text-right">
                <button
                  v-if="canEdit"
                  type="button"
                  class="btn btn-primary"
                  @click="goToCreate"
                >
                  <i class="fas fa-plus"></i> เพิ่มข้อมูลตามเป้าหมาย
                </button>
              </div>
            </div>
          </form>
          <!-- end: Search Form -->

          <!--begin: Datatable -->
          <div class="row">
            <div class="col-lg-12 table-responsive">
              <table
                class="table-sm table-striped- table-bordered table-hover table-checkable"
                id="stockCoverDaysTable"
              >
                <thead>
                  <tr>
                    <th class="all text-center" style="width: 15%;">คลังสินค้า</th>
                    <th class="all text-center" style="width: 30%;">ชื่อสินค้า (ข้อมูลตามเป้าหมาย)</th>
                    <th class="all text-center" style="width: 10%;">ปี</th>
                    <th class="all text-center" style="width: 15%;">วันที่บันทึกล่าสุด</th>
                    <th class="all text-center" style="width: 15%;">สถานะ</th>
                    <th class="all text-center" style="width: 15%;">คำสั่ง</th>
                  </tr>
                </thead>
              </table>
            </div>
          </div>
          <!--end: Datatable -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import axios from "axios";
import router from "../../router";
import select2 from "../../Shared/Select2";
import DatatableWarning from "../../Shared/DatatableWarning";

require("datatables.net-bs4");
require("datatables.net-responsive-bs4");
require("sweetalert2");

// Status toggle — active (green): click to deactivate. Grain = (plant, year).
let StatusActionsTrue = Vue.extend({
  template: `
  <div>
    <a v-if="canEdit" href="#" class="btn btn-sm btn-success" @click.prevent="toggleStatus">
      <i class="fas fa-play"></i> เปิดใช้งาน
    </a>
    <span v-else class="badge badge-success">เปิดใช้งาน</span>
  </div>`,
  props: ['canEdit'],
  methods: {
    toggleStatus: function() {
      toggleScvdStatus(this, "หลังจากกดแล้วจะส่งผลให้สถานะถูกปิดใช้งาน");
    },
  },
});

let StatusActionsFalse = Vue.extend({
  template: `
  <div>
    <a v-if="canEdit" href="#" class="btn btn-sm btn-danger" @click.prevent="toggleStatus">
      <i class="fas fa-pause"></i> ปิดใช้งาน
    </a>
    <span v-else class="badge badge-danger">ปิดใช้งาน</span>
  </div>`,
  props: ['canEdit'],
  methods: {
    toggleStatus: function() {
      toggleScvdStatus(this, "หลังจากกดแล้วจะส่งผลให้สถานะถูกเปิดใช้งาน");
    },
  },
});

// Shared toggle handler — PUT /ToggleStatus with { plantCode, year, inActiveStatus } (R2-30: grain plant×year×สถานะ — List แยกแถว active/inactive)
function toggleScvdStatus(ctx, detailText) {
  let self = ctx;
  Swal.fire({
    title: "คำสั่งแก้ไขสถานะ",
    type: "warning",
    html: "กรุณายืนยันคำสั่งแก้ไขสถานะ " + detailText,
    showCancelButton: true,
    confirmButtonText: "ยืนยัน",
    cancelButtonText: "ยกเลิก",
    showLoaderOnConfirm: true,
  }).then((result) => {
    if (result.value) {
      KTApp.blockPage({
        opacity: 0.05,
        message: "กำลังแก้ไขสถานะ กรุณารอสักครู่...",
      });

      axios
        .put(
          "/Api/StockCoverDayTarget/ToggleStatus",
          { plantCode: self.data.plantCode, year: self.data.year, inActiveStatus: !self.data.isActive },
          {
            headers: {
              Authorization: "Bearer " + self.$root.user.access_token,
            },
          }
        )
        .then(function(response) {
          if (response.data.success) {
            self.$parent.reloadDataTable();
            Swal.fire("สำเร็จ", "ปรับปรุงสถานะการใช้งานสำเร็จ", "success");
          } else {
            Swal.fire("เกิดข้อผิดพลาด", response.data.message, "error");
          }
        })
        .catch(function(error) {
          var errorMsg = error.response && error.response.data && error.response.data.message
            ? error.response.data.message
            : "เกิดข้อผิดพลาด";
          Swal.fire("เกิดข้อผิดพลาด", errorMsg, "error");
        })
        .then(function() {
          KTApp.unblockPage();
        });
    }
  });
}

// List 🗑️ — soft-delete (ซ่อน) ทั้ง (plant, year) = ทุกสินค้า×version. Grain = plant×year (wireframe §1.1).
// หมายเหตุ: 🗑️ ราย card (สินค้า×version) อยู่ที่หน้า Detail แยกต่างหาก.
function deleteScvdPlantYear(ctx) {
  let self = ctx;
  Swal.fire({
    title: "ยืนยันการลบข้อมูล",
    type: "warning",
    html:
      "ต้องการซ่อน/ลบข้อมูลทั้งหมดของคลังนี้ (ทุกสินค้า/ทุกเวอร์ชันของปีนี้) ใช่หรือไม่?<br/>" +
      "<small class='text-muted'>เปิดกลับต้องติดต่อผู้ดูแลระบบ</small>",
    showCancelButton: true,
    confirmButtonText: "ยืนยันลบ",
    cancelButtonText: "ยกเลิก",
    showLoaderOnConfirm: true,
  }).then((result) => {
    if (result.value) {
      KTApp.blockPage({
        opacity: 0.05,
        message: "กำลังลบข้อมูล กรุณารอสักครู่...",
      });

      axios
        .post(
          "/Api/StockCoverDayTarget/DeleteByPlantYear",
          { plantCode: self.data.plantCode, year: self.data.year, inActiveStatus: !self.data.isActive },
          {
            headers: {
              Authorization: "Bearer " + self.$root.user.access_token,
            },
          }
        )
        .then(function(response) {
          if (response.data.success) {
            self.$parent.reloadDataTable();
            Swal.fire("สำเร็จ", "ลบข้อมูลสำเร็จ", "success");
          } else {
            Swal.fire("เกิดข้อผิดพลาด", response.data.message, "error");
          }
        })
        .catch(function(error) {
          var errorMsg = error.response && error.response.data && error.response.data.message
            ? error.response.data.message
            : "เกิดข้อผิดพลาด";
          Swal.fire("เกิดข้อผิดพลาด", errorMsg, "error");
        })
        .then(function() {
          KTApp.unblockPage();
        });
    }
  });
}

// Row actions — 🔍 View, ✏️ Edit, 🗑️ Delete (ซ่อนทั้ง plant×year). Delete ราย card อยู่หน้า Detail.
let StockCoverDaysActions = Vue.extend({
  template: `
  <div>
    <a :href="viewUrl" @click.prevent="viewTarget" class="btn btn-sm btn-clean btn-icon btn-icon-md" title="ดูรายละเอียด">
      <i class="fas fa-search"></i>
    </a>
    <a v-if="canEdit && !isPastYear && data.isActive" :href="editUrl" @click.prevent="editTarget" class="btn btn-sm btn-clean btn-icon btn-icon-md" title="แก้ไขข้อมูล">
      <i class="la la-edit"></i>
    </a>
    <a v-if="canEdit" href="#" @click.prevent="deleteTarget" class="btn btn-sm btn-clean btn-icon btn-icon-md" title="ซ่อน/ลบข้อมูล">
      <i class="la la-trash text-danger"></i>
    </a>
  </div>`,
  props: ['canEdit'],
  computed: {
    // R2-28: ปีที่ผ่านไปแล้วแก้ไขไม่ได้ (BE: IsEditable = Year >= ปีปัจจุบัน) → ซ่อนปุ่มแก้ไข · ปุ่มดู/ลบคงไว้
    isPastYear: function () { return Number(this.data.year) < new Date().getFullYear(); },
    // R2-18: real href so right-click → "open in new tab" lands on the View/Edit route (was href="#" → /#)
    viewUrl: function () { return '/StockCoverDays/View/' + this.data.plantCode + '/' + this.data.year + (this.data.isActive ? '' : '?status=inactive'); },
    editUrl: function () { return '/StockCoverDays/Edit/' + this.data.plantCode + '/' + this.data.year; },
  },
  methods: {
    viewTarget: function () {
      // R2-30 — แถวปิดใช้งาน → View แสดงเฉพาะรายการที่ปิดใช้งาน
      router.push({ path: `/StockCoverDays/View/${this.data.plantCode}/${this.data.year}`, query: this.data.isActive ? {} : { status: "inactive" } });
    },
    editTarget: function () {
      router.push({ path: `/StockCoverDays/Edit/${this.data.plantCode}/${this.data.year}` });
    },
    deleteTarget: function () {
      deleteScvdPlantYear(this);
    },
  },
});

export default {
  components: {
    select2,
  },
  computed: {
    // สิทธิ์แก้ไข — SCVD WRITE = Admin + Team (Viewer ไม่ผ่าน); super_admin ผ่านเสมอผ่าน canShow (AUTHORIZE_WRITE)
    canEdit: function () {
      return this.$root.canShow([["SCVD_ADMIN", "COMPANY_PROFILE_TYPE_SCVD"], ["SCVD_TEAM_EDIT", "COMPANY_PROFILE_TYPE_SCVD"]]);
    },
  },
  data: function () {
    var self = this;
    // Year options: current year - 1, current year, current year + 1 (M14/B.3)
    const currentYear = new Date().getFullYear();
    const yearData = [
      { id: (currentYear + 1).toString(), text: (currentYear + 1).toString() },
      { id: currentYear.toString(), text: currentYear.toString() },
      { id: (currentYear - 1).toString(), text: (currentYear - 1).toString() },
    ];

    return {
      searchPlant: null,
      searchYear: currentYear.toString(), // Default: current year
      searchStatus: "1", // Default: ใช้งาน
      searchYearOptions: {
        placeholder: "เลือกปี",
        allowClear: true,
        data: yearData,
      },
      statusOptions: {
        placeholder: "ทั้งหมด",
        allowClear: true,
        data: [
          { id: "1", text: "ใช้งาน" },
          { id: "0", text: "ไม่ใช้งาน" },
        ],
      },
      // Plant Select2 — scoped ajax + เฉพาะคลังที่ติ๊ก "ใช้งาน SCVD" (F6, /Api/StockCoverDayTarget/Select2Plant)
      plantOptions: {
        placeholder: "เลือก คลังสินค้า",
        allowClear: true,
        ajax: {
          url: "/Api/StockCoverDayTarget/Select2Plant",
          type: "post",
          dataType: "json",
          contentType: "application/json",
          data: function (params) {
            var query = {
              search: params.term,
              page: params.page || 1,
            };
            return JSON.stringify(query);
          },
          processResults: function (data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more,
              },
            };
          },
          transport: function (params, success, failure) {
            params.beforeSend = function (request) {
              request.setRequestHeader(
                "Authorization",
                "Bearer " + self.$root.user.access_token
              );
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          },
        },
      },
    };
  },
  methods: {
    formReset: function (e) {
      // ล้างค่าทั้งหมด = reset filter ค้นหา (ไม่ได้ลบข้อมูลจริง — M15)
      this.searchPlant = null;
      this.searchYear = null;
      this.searchStatus = null;
      $("#scvdList_plantKey").val("").trigger("change");
      $("#scvdList_yearKey").val("").trigger("change");
      $("#scvdList_statusKey").val("").trigger("change");
      this.formSubmit(e);
    },
    formSubmit: function (e) {
      e.preventDefault();
      var table = $("#stockCoverDaysTable").DataTable();
      table.search();
      table.draw();
    },
    reloadDataTable: function (resetPaging = false) {
      $("#stockCoverDaysTable")
        .DataTable()
        .ajax.reload(null, resetPaging);
    },
    goToCreate: function () {
      router.push({ path: "/StockCoverDays/Create" });
    },
  },
  async mounted() {
    let self = this;

    // Set default values for dropdowns
    await this.$nextTick();
    const currentYear = new Date().getFullYear();
    $("#scvdList_statusKey").val("1").trigger("change");
    $("#scvdList_yearKey").val(currentYear.toString()).trigger("change");

    $.fn.dataTable.ext.errMode = "none";
    var table = $("#stockCoverDaysTable");
    table
      .DataTable({
        responsive: true,
        processing: true,
        serverSide: true,
        searchDelay: 500,
        ajax: {
          url: "/Api/StockCoverDayTarget/Search",
          type: "post",
          dataType: "json",
          contentType: "application/json",
          beforeSend: function (request) {
            request.setRequestHeader(
              "Authorization",
              "Bearer " + self.$root.user.access_token
            );
          },
          data: function (d) {
            return JSON.stringify(
              $.extend(d, {
                PlantCode: self.searchPlant,
                Year: self.searchYear,
                Status: self.searchStatus,
              })
            );
          },
        },
        dom: `<'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 dataTables_pager'lp>>
        <'row'<'col-sm-12'tr>>
        <'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 dataTables_pager'lp>>`,
        lengthMenu: [50, 100, 200, 500],
        pageLength: 100,
        language: {
          lengthMenu: "Display _MENU_",
        },
        order: [[0, "asc"], [2, "desc"]], // Plant (asc), then Year (desc)
        columns: [
          { data: "plantName", className: "text-center", width: "15%" },
          {
            data: "products",
            className: "text-left",
            width: "30%",
            orderable: false,
            render: function (data, type, full, meta) {
              if (data && data.length > 0) {
                return data
                  .map(function (p) {
                    return "[" + p.productCode + "] " + p.productName;
                  })
                  .join("<br/>");
              }
              return "-";
            },
          },
          { data: "year", className: "text-center", width: "10%" },
          {
            data: "lastUpdatedDate",
            className: "text-center",
            width: "15%",
            render: function (data, type, full, meta) {
              if (data) {
                var d = new Date(data);
                var day = String(d.getDate()).padStart(2, "0");
                var month = String(d.getMonth() + 1).padStart(2, "0");
                var year = d.getFullYear();
                return day + "/" + month + "/" + year;
              }
              return "-";
            },
          },
          {
            data: "isActive",
            className: "text-center",
            width: "15%",
            orderable: false,
            render: function (data, type, full, meta) {
              return '<div class="actionsStatus"></div>';
            },
          },
          {
            data: "plantCode",
            className: "text-center",
            width: "15%",
            orderable: false,
            render: function (data, type, full, meta) {
              return '<div class="actions"></div>';
            },
          },
        ],
      })
      .on("preXhr.dt", function () {
        KTApp.block(self.$refs.searchForm, {
          showOverlay: false,
          opacity: 0.05,
          message: "กำลังค้นหาข้อมูล กรุณารอสักครู่...",
        });
      })
      .on("error.dt", function (e, settings, techNote, message) {
        DatatableWarning.alert(techNote);
      })
      .on("xhr.dt", function () {
        KTApp.unblock(self.$refs.searchForm);
      })
      .on("draw.dt", function () {
        $(".actionsStatus").each(function (i, el) {
          var $dt = table.DataTable();
          var $tr = $(el).parents("tr").first();
          var data = $dt.row($tr).data();
          if (data) {
            // isActive: true = Active, false = Inactive
            if (data.isActive) {
              new StatusActionsTrue({ data: { data }, parent: self, propsData: { canEdit: self.canEdit } }).$mount(el);
            } else {
              new StatusActionsFalse({ data: { data }, parent: self, propsData: { canEdit: self.canEdit } }).$mount(el);
            }
          }
        });
        $(".actions").each(function (i, el) {
          var $dt = table.DataTable();
          var $tr = $(el).parents("tr").first();
          var data = $dt.row($tr).data();
          if (data) {
            new StockCoverDaysActions({ data: { data }, parent: self, propsData: { canEdit: self.canEdit } }).$mount(el);
          }
        });
      });
  },
};
</script>

<style lang="scss">
.select2,
.select2-dropdown {
  font-size: 1rem !important;
}
</style>



// WEBPACK FOOTER //
// App/Components/StockCoverDays/StockCoverDaysList.vue